const BASE_URL = "http://64.227.146.132:8080";
// const BASE_URL = "http://localhost:8080";

export async function getCompanies() {
  const response = await fetch(`/api/companies`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
}

export async function getCompanyBySlug(slug) {
  const response = await fetch(`/api/companies/${slug}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
}
